import { AsyncPipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { AngularFireAnalytics } from "@angular/fire/compat/analytics";
import { Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { IonicModule, NavController } from "@ionic/angular";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { BehaviorSubject } from "rxjs";

@Component({
  selector: "app-fork2",
  templateUrl: "./fork2.page.html",
  styleUrls: ["./fork2.page.scss"],
  standalone: true,
  imports: [
    IonicModule,
    AsyncPipe,
    TranslatePipe,
  ],
})
export class Fork2Page implements OnInit {
  steps = [
    {
      iconSrc: "../../../assets/icon/1.png",
      subtitle: "Create your <br> syndicate",
    },
    {
      iconSrc: "../../../assets/icon/2.png",
      subtitle: "Pick your <br> numbers",
    },
    {
      iconSrc: "../../../assets/icon/3.png",
      subtitle: "Invite your <br> friends",
    },
  ];
  data$ = new BehaviorSubject<boolean>(false);
  public userId: string;
  constructor(
    private router: Router,
    private navCtrl: NavController,
    private analytics: AngularFireAnalytics,
    public translate: TranslateService,
    private authService: AuthService
  ) {
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        translate.use(l ? l : "en");
      },
      (err) => {
        return err;
      }
    );
  }

  async ngOnInit() {
    await this.authService
      ?.getUid("Fork2Page")
      ?.then((uid) => {
        this.userId = uid;
      })
      .catch((error) => {
        return error;
      });
    this.analytics.logEvent("Fork2_page", { userId: this.userId });
    this.translate.get(["fork2.subtitle", "fork2.Pick", "fork2.Invite"]).subscribe(
      (res: string) => {
        this.steps = [];
        this.steps.push(res["fork2.subtitle"], res["fork2.Pick"], res["fork2.Invite"]);
        setTimeout(() => {
          this.data$.next(true);
        }, 2500);
      },
      (err) => {
        return err;
      }
    );
  }

  backToTabs() {
    this.router.navigate(["/mainTabs/tabs/home"]);
  }

  startPrivateSyndicateJourney() {
    this.router.navigate(["/private-syndicate"]);
  }

  goToStore() {
    this.router.navigateByUrl("/mainTabs/tabs/store");
  }
  goToFreeReg4c() {
    this.router.navigateByUrl("/free-reg-step4c?prosub_id=3157");
  }
}
